import store from "store";
let regData = store.get('regDataRf1');
let initialState = {
  type: '',
  extension: '',
  phone: '',
  token: '',
  code: ''
};
if (regData) {
  initialState = {
    type: '',
    extension: '',
    phone: regData.phone,
    token: regData.token,
    code: ''
  };
}


export default function signVerifyForm(state = initialState, action) {
  switch (action.type) {
    case 'RESET_SIGN_FORM':
      return initialState;
    case 'SET_DATA_OWNER':
      return {
        ...state,
        token: action.payload.token,
        phone: action.payload.phone
      };
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/forms/signVerifyForm.js
 **/